import type React from "react";
import { ReactComponent as Svg } from "./assets/prize.svg";
import * as styles from "./Icon.module.scss";

type PrizeProps = React.SVGProps<SVGSVGElement>;

export const Prize = ({ className, ...props }: PrizeProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
